import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandler } from 'common-lib';
import { CommonConstants, ContactUsRequest, CurrentState, UserService } from "common-lib"
import { PortalAppState } from "../../../store/reducer";
import { SendContactUsMessageFailed, SetPhoneAndEmail } from "common-lib";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.page.html',
    styleUrls: ['./contact.page.scss'],
    standalone: false
})
export class ContactPage implements OnDestroy {
  private userSubscription: Subscription;
  form: UntypedFormGroup;

  constructor(
    protected store: Store<PortalAppState>,
    private currentState: CurrentState<PortalAppState>,
    protected router: Router,
    private us: UserService,
    private translateService: TranslateService,
    protected formBuilder: UntypedFormBuilder,
  ) {

    this.userSubscription = this.store.select(state => state.user.userDetails).subscribe(ud => {
      this.form = this.formBuilder.group({
        email: [ud.email, [Validators.required, Validators.email]],
        phoneNumber: [ud.phoneNumber, [Validators.required]],
        message: [null, [Validators.required]],
        })
    })

  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
  }

  getPageName() {
    return 'ContactPage';
  }

  getEmailAnchor() {
    const emailAddress = this.translateService.instant('CONTACT_PAGE.CONTACT_US_MESSAGE_BY_EMAIL_EMAIL_ADDRESS');
    let subject = this.translateService.instant('CONTACT_PAGE.CONTACT_US_MESSAGE_BY_EMAIL_EMAIL_SUBJECT');
    let href = "mailto:" + emailAddress + "?subject=" + subject;
    return href;
  }

  getPhoneAnchor() {
    const phone = this.translateService.instant('CONTACT_PAGE.CONTACT_US_MESSAGE_BY_EMAIL_PHONE_PART');
    let href = "tel::" + phone;
    return href;
  }

  sendMessage() {
    const userName = this.currentState.snapshot.user.userDetails.userName;
    const userId = this.currentState.snapshot.user.userDetails.id;
    const request: ContactUsRequest = {
      userId: userId,
      message: this.form.value.message,
      emailAddress: this.form.value.email,
      userName: userName,
      phoneNumber: this.form.value.phoneNumber,
    };
    console.log(request);
    this.store.dispatch(new SetPhoneAndEmail({phone: this.form.value.phoneNumber, email: this.form.value.email}));
    this.us.sendContactUsEmail(request).pipe(catchError(error => {
      return new Observable<Action>((observer) => {
        observer.next(new SendContactUsMessageFailed(ErrorHandler.getErrorEntry(error)));
        observer.complete()
      });
    })).subscribe(response => {
      if (response instanceof HttpErrorResponse || response instanceof SendContactUsMessageFailed) {
        console.error("Error during send contact us message");
        console.error(response);
      } else {
        // TODO success toast
      }
    });
  }

}
